module.exports = __webpack_public_path__ + "img/pin-star-1000.af971158.png";